export class MouldLogEntry {
  public constructor(
    public id: string,
    public hasLongText: boolean,
    public shortText: string,
    public statusText: string,
    public user: string,
    public codeNumber: string,
    public longText: string,
    public logDate?: Date
  ) {}
}
